import React from 'react';
import { Helmet } from 'react-helmet-async';

const LegalPageLayout = ({ title, children }) => {
    return (
        <div className="min-h-screen bg-[#F0F9FF] py-12 px-6">
            <div className="max-w-4xl mx-auto bg-white p-10 rounded-[32px] shadow-sm border border-slate-100">
                <h1 className="text-3xl font-black text-slate-900 mb-8">{title}</h1>
                <div className="prose prose-slate max-w-none text-slate-600">
                    {children}
                </div>
            </div>
        </div>
    );
};

export const MentionsLegales = () => (
    <>
        <Helmet>
            <title>Mentions Légales | Trouve ton VIE</title>
            <meta name="description" content="Informations légales du site Trouve ton VIE : éditeur, hébergeur, propriété intellectuelle et responsabilités." />
            <link rel="canonical" href="https://trouvetonvie.fr/mentions-legales" />
            <meta property="og:locale" content="fr_FR" />
            <meta property="og:site_name" content="Trouve ton VIE" />
        </Helmet>
        <LegalPageLayout title="Mentions Légales">
            <p>Contenu à venir...</p>
        </LegalPageLayout>
    </>
);

export const CGU = () => (
    <>
        <Helmet>
            <title>Conditions Générales d'Utilisation | Trouve ton VIE</title>
            <meta name="description" content="Conditions générales d'utilisation du site Trouve ton VIE. Lisez les règles d'accès et d'utilisation du service." />
            <link rel="canonical" href="https://trouvetonvie.fr/cgu" />
            <meta property="og:locale" content="fr_FR" />
            <meta property="og:site_name" content="Trouve ton VIE" />
        </Helmet>
        <LegalPageLayout title="Conditions Générales d'Utilisation (CGU)">
            <p>Contenu à venir...</p>
        </LegalPageLayout>
    </>
);

export const Confidentialite = () => (
    <>
        <Helmet>
            <title>Politique de Confidentialité | Trouve ton VIE</title>
            <meta name="description" content="Découvrez comment Trouve ton VIE collecte, utilise et protège vos données personnelles conformément au RGPD." />
            <link rel="canonical" href="https://trouvetonvie.fr/confidentialite" />
            <meta property="og:locale" content="fr_FR" />
            <meta property="og:site_name" content="Trouve ton VIE" />
        </Helmet>
        <LegalPageLayout title="Politique de Confidentialité">
            <p>Contenu à venir...</p>
        </LegalPageLayout>
    </>
);

export const Contact = () => (
    <>
        <Helmet>
            <title>Contactez Trouve ton VIE</title>
            <meta name="description" content="Une question, un partenariat ou un retour ? Contactez l'équipe de Trouve ton VIE." />
            <link rel="canonical" href="https://trouvetonvie.fr/contact" />
            <meta property="og:locale" content="fr_FR" />
            <meta property="og:site_name" content="Trouve ton VIE" />
        </Helmet>
        <LegalPageLayout title="Contact">
            <p>Contenu à venir...</p>
        </LegalPageLayout>
    </>
);
